
export const VocabLanguageSelector = {
    'spanish': ['Español', 'Spanish'],
    'english': ['Ingles', 'English'],
  }
    